import React from "react";

const PrivacyPolicy = () => (
  <div className="max-w-4xl mx-auto p-6 text-left">
    <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
    <p>
      Your privacy is our top priority. We are committed to providing
      simple, fun, and privacy-first network diagnostics without tracking,
      storing, or sharing any of your personal data.
    </p>
    <p className="mt-4">
      <strong>No Tracking:</strong> We do not use cookies, analytics, or any other
      tracking methods to collect information about you.
    </p>
    <p className="mt-4">
      <strong>No Data Collection:</strong> We do not store or share any personally
      identifiable information.
    </p>
    <p className="mt-4">
      <strong>Privacy-First Design:</strong> Our services are built with your privacy
      in mind, ensuring that you remain untracked and your data stays private.
    </p>
    <p className="mt-4">
      If you have any questions or concerns, please feel free to contact us.
    </p>
  </div>
);

export default PrivacyPolicy;
